// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__sLqfq","inner":"Footer_inner__2SgZm"};